import { Button, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { requestUrl } from '../utils/constants';
import Image403 from '../assets/images/403.svg';

const Error = () => {
  return (
    <Box
      sx={{
        background: '#F5F5F5',
        borderRadius: '0px',
        padding: '0px',
        width: '100%',
        margin: '0 auto 0',
        minHeight: '100vh',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Grid container sx={{ width: '100%', maxWidth: '715px', padding: '20px 20px 50px', textAlign: 'center' }}>
        <Grid item xs={12}>
          <Box sx={{ textAlign: 'center' }}>
            <img src={Image403} alt="" />
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 500, fontSize: '40px', margin: '40px 0 0 0' }}>
            We are Sorry...
          </Typography>
          <Typography mt={1} sx={{ fontWeight: 400, fontSize: '20px' }}>
            You do not have access to Vehicle 360. If you need access or should have access and are experiencing an
            issue, please submit a request using the button below.
          </Typography>
          <Button
            variant="outlined"
            sx={{
              mt: 4.5,
              backgroundColor: '#456BD9',
              color: '#fff',
              width: '180px',
              fontSize: '14px',
              fontWeight: '300',
              textTransform: 'capitalize',
              '&:hover': { color: '#456BD9' },
            }}
            onClick={() => {
              window.open(requestUrl, '_blank');
            }}
          >
            Submit Request
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Error;
